module.exports = __webpack_public_path__ + "static/img/connectbg.87e98718.png";